import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "../../store";
import { AnalyticState } from "@/store/analytics/types";
import AnalyticsApi from "@/utils/api/analytics";

@Module({ dynamic: true, name: "analytics", store })
class Analytics extends VuexModule implements AnalyticState {
  public summaryData: AnalyticSummaryData = {
    clicks: 0,
    currency: "USD",
    items_sold: 0,
    items_sold_conversion_rate: 0,
    last_updated_timestamp: new Date(),
    locale: "zh-Hans",
    net_commissions: "",
    order_conversion_rate: 0,
    orders: 0
  };

  public account_admin = false;

  @Mutation
  public setAnalyticSummaryData(data: AnalyticSummaryData) {
    this.summaryData = data;
  }

  @Mutation
  public setAccountAdmin(data: boolean) {
    this.account_admin = data;
  }

  @Action({ commit: "setAnalyticSummaryData", rawError: true })
  public async getAnalyticSummaryData(payload: any) {
    const { startdate, enddate } = payload;
    const response = await AnalyticsApi.getSummary(startdate, enddate);

    return response.data;
  }

  @Action({ commit: "setAccountAdmin", rawError: true })
  public async getAccountAdmin() {
    const response = await AnalyticsApi.getContributorInfo();
    return response;
  }
}

export default getModule(Analytics);
